import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, distinctUntilChanged, interval } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { MultipleContextComponent } from '../multiple-context/multiple-context.component';
import { ConfigLogComponent } from '../config-log/config-log.component';
import { FlowModalComponent } from '../../flow-action/flowaction.component';
import { flowData } from 'src/app/interfaces/flowData';
import { action } from 'src/app/interfaces/action';
import { PermissionServices } from 'src/app/services/permission.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { OptionDialogItens } from 'src/app/system-utils/option-dialog/option-dialog.component';
import { HTTPServiceWorker } from 'src/app/services/http.service.worker';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { ThemeService } from 'src/app/services/theme.service';




@Component({
    selector: 'app-main-configuracao-grid-card',
    templateUrl: './main-configuracao-grid-card.component.html',
    styleUrls: ['./main-configuracao-grid-card.component.scss'],
    providers: [HTTPServiceWorker],
    standalone: false
})
export class MainConfiguracaoGridCardComponent implements OnInit {

  idconf;
  name;
  codemktp;
  namemarketplace;
  status;
  tipo
  mktpcfg:any[] = [];
  mktpcfg_temp:any[] = [];
  sub2: Subscription;
  sub3: Subscription;
  gridMode = true;
  canInsert:Boolean = false;
  canEdit:Boolean = false;

  inputFilter:FormControl<string> = new FormControl();
  filterColor:string = "primary";
  filterStatus:FormControl<string> = new FormControl();
  filterActive:FormControl<string> = new FormControl();
  filterCompany:FormControl<string> = new FormControl();
  filterMulti:FormControl<string> = new FormControl();
  filterMarketplace:FormControl<string> = new FormControl();
  filterTipo:FormControl<string> = new FormControl();
  filterServer:FormControl<string> = new FormControl();
  threadDetailsSubscription:Subscription;
  loading = false;  
  userConfig:{workRefresh:boolean} = {
      workRefresh: false
  };

  multiList:{key:string,name:string}[] = [
    {
      key:'S',
      name:'Múltiplos Contextos'
    },
    {
      key:'N',
      name:'Contexto Único'
    }
  ];
  
  companyList:{key:string,name:string}[] = [];
  marketPlaceList:{key:string,name:string}[] = [];
  typeList:{key:string,name:string}[] = [];

  companyListFiltered:{key:string,name:string}[] = [];
  marketPlaceListFiltered:{key:string,name:string}[] = [];
  typeListFiltered:{key:string,name:string}[] = [];

  serverList:{key:string,name:string}[] = [];
  activeList:{key:string,name:string}[] = [
    {
      key:'S',
      name:'Ativo'
    },
    {
      key:'N',
      name:'Inativo'
    }
  ];

  statusList:{key:string,name:string}[] = [
      {
        key:'RUNNABLE',
        name:"Executando"
      },
      {
        key:'BLOCKED',
        name:"Bloqueado"
      },
      {
        key:'TIMED_WAITING',
        name:"Esperando"
      },
      {
        key:'STOPPED',
        name:"Parado"
      }  
  ];

  //@ViewChild(CdkVirtualScrollViewport, { static: false }) private cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  @ViewChild('scrollcontainer') private scrollContainer:ElementRef;

  controle:{key:string,value:any}[] = [];
  insert: any;
  data: { evento: string; row: any; formGroup: any; };
  mktpcfgcompany: Object[] = [];
  mktpcfgcompany_temp: object[] = [];
  interval: NodeJS.Timeout;
  canView: Boolean;
  openMenu: boolean = false;
  threads: Object;
  timeOut: NodeJS.Timeout;
  worker: Worker;
  width: number = 300;
  readonly minWidth = 300;
  widthScrollContainer: any;
  threadKill: Subscription;
  canDelete: Boolean;
  
  constructor(private http:HTTPService, private spinner:NgxSpinnerService, private uas:UserAuthenticationServices,
      private dialogServices:DialogService,
      private userPermission:PermissionServices,
      private snackbar:SnackbarService,
      public httpWorker:HTTPServiceWorker,
      public cd:ChangeDetectorRef,
      public breakpointObserver: BreakpointObserver,
      public ucs:UserConfigServices,
      public ThemeService:ThemeService
      ) { }

  ngAfterViewInit(){
    if ( this.canView){
      this.loadData(null).then(r=>{
        this.widthScrollContainer = this.scrollContainer.nativeElement.offsetWidth;
        this.recalculateView(this.widthScrollContainer);
      });  
    }
  }

  refresh(){
    if ( this.canView){
      this.openMenu =!this.openMenu;
      this.loadData(null).then(r=>{
        setTimeout(()=>{
          this.recalculateView(this.widthScrollContainer);
        },100);        
      });  
    }
  }

  onChangeWorkRefresh(){
      // this.userConfig = {
      //   'workRefresh':this.workRefresh
      // }
      this.saveUserConfig();
  }

  clickMenu(){
    this.openMenu = !this.openMenu;
  }
  
  
  

  filterData(){
    
    if ( this.controle.length == 0){
      this.mktpcfg = this.mktpcfg_temp;
      this.recalculateView(this.widthScrollContainer);
      return;
    }
    let array  = this.mktpcfg_temp;

    this.mktpcfg  = array.filter(line=>{
      let canShow:{key:string,show:boolean}[]  = [];
      for ( var con of this.controle){
        let tipo = con.key;
        let data:Object[] = con.value;

        if ( line[tipo] == null ){
          for ( var d of data){
            if ((line['DATA'] as Object[]).findIndex(data=>data[tipo] ==d)  > -1 ){
                if ( canShow.findIndex(d=>d.key==tipo) == -1){
                  canShow.push({key:tipo,show:true});
                }
            }
          }
        }else{
            for ( var d of data){
              if ( line[tipo] == d){
                if ( canShow.findIndex(d=>d.key==tipo) == -1){
                  canShow.push({key:tipo,show:true});
                }
              }
            } 
        }
      }

      if ( canShow.length == this.controle.length){
        return true;
      }else{
        return false;
      }
    });
    
    //this.recalculateView('E');
    this.recalculateView(this.widthScrollContainer);
  }

  saveUserConfig(){
    
    return new Promise((resolve,reject)=>{
      let jsonDec:Object ={
        "entityName":"Mktpdic",
        "condition":`instancename='MKTPCFG'`
      };
      
      this.ucs.saveUserCfg(jsonDec,this.uas.user.iduser,[],this.userConfig).then(me=>{
        resolve(true);
      }, error=>{
        throw error;
      });
    });      
   
  }

  getBadge(control:FormControl){
      if ( ObjectUtil.isNotEmpty(control.value)){
        if ( control.value instanceof Array ){
          return control.value.length;
        }else{
            return 1;
        }
      }
      return null;
      
  }

  getStatusName(item){
      if( item['STATUS']!= null ){
        let statusCode=  this.statusList.find(d=>d.key == item['STATUS']);
        if ( statusCode != null ){
          return statusCode.name;
        }else{
          return item['STATUS'];
        }
      }else{
        return 'Sem STATUS';
      }
      
  }

  checkData(tipo,data){
    
    let index = this.controle.findIndex(d=>d.key == tipo);

    if ( ObjectUtil.isNotEmpty(data)){
      if ( index  == -1 ){
          this.controle.push({key:tipo,value:data});
      }else{
        this.controle[index].value = data;
      }
    }else{
      if ( index  > -1 ){
        this.controle.splice(index,1);
      }
    }
    if ( this.controle.length > 0 || ObjectUtil.isNotEmpty(this.inputFilter.value )){
      this.filterColor = 'warn';
    }else{
        this.filterColor = 'primary';
    }

    this.filterData();
  }

  onResize(event) {
    let innerWidth = event.target.innerWidth;
    this.recalculateView(innerWidth);
  }

  ngOnInit(): void {
    
    this.ucs.loadUserConfig(this.uas.user.iduser,'MKTPCFG').subscribe(data=>{
        let config = data['Mktpusercfg'][0]['CONFIG'];
        if ( config ){
          this.userConfig = JSON.parse(config);
        }
    })
   
    this.canEdit = this.userPermission.checkPermissionSession('MKTPCFG','edit');
    this.canInsert = this.userPermission.checkPermissionSession('MKTPCFG','insert');
    this.canView = this.userPermission.checkPermissionSession('MKTPCFG','view');
    this.canDelete = this.userPermission.checkPermissionSession('MKTPCFG','delete');

    this.filterStatus.valueChanges.subscribe(data=>this.checkData('STATUS',data));
    this.filterActive.valueChanges.subscribe(data=>this.checkData('ACTIVE',data));
    this.filterCompany.valueChanges.subscribe(data=>this.checkData('CODECOMPANY',data));
    this.filterMulti.valueChanges.subscribe(data=>this.checkData('MULTI',data));
    this.filterMarketplace.valueChanges.subscribe(data=>this.checkData('CODEMKTP',data));
    this.filterTipo.valueChanges.subscribe(data=>this.checkData('IDTPI',data));
    this.filterServer.valueChanges.subscribe(data=>this.checkData('SERVERNAME',data));
    //this.recalculateView('C');

    if (typeof Worker !== 'undefined') {
      // Create a new
      this.worker = new Worker(new URL('./main-configuracao-grid-card.component.ts.worker', import.meta.url));
      this.worker.onmessage = ({ data }) => {
          if ( data!= null && data.cfg != null && (data.cfg as Object[]).length > 0 ){
            setTimeout(()=>{
              this.mktpcfg_temp = data.cfg;
              this.threads = data.threads;
              this.filterData();
              if ( this.inputFilter.value != null ){
                this.doFilter(this.inputFilter.value);
              }
              this.loading = false;
            },100);
          }
      };
      let data = {
          cfg: this.mktpcfg_temp,
          aut: this.uas.user
      }
      if ( this.canView) {
        this.worker.postMessage(data);
      }
      
    } else {
      console.log("Não suportado Worker");
    }

    setInterval(() => {

      if ( this.userConfig.workRefresh && this.canView){
        let data = {
          cfg: this.mktpcfg_temp,
          aut: this.uas.user
        }
        this.loading = true;
        this.worker.postMessage(data);
      }
      
    },20000);
  }

  
  
  ngOnDestroy(){
      
      if ( this.sub2!= null ) {this.sub2.unsubscribe()};
      if ( this.sub3!= null ) {this.sub3.unsubscribe()};
      if ( this.threadDetailsSubscription!= null ){this.threadDetailsSubscription.unsubscribe()}
      if ( this.interval != null ){ clearInterval(this.interval)}
      if ( this.timeOut != null){ clearTimeout(this.timeOut);}
      if ( this.threadKill!= null ){this.threadKill.unsubscribe();}
      this.worker.terminate();
  }


  trackById(index: number, item: Object) {
    return item['IDCONF'];
  }
  
  onScroll(any){
    
  }

  itemChange(item){

    if ( item['activeBOO']==true){
      item['ACTIVE']='S';
    }else{
      item['ACTIVE']='N';
    }

    this.changeData(item).then(data=>{
        if ( data ){
          this.snackbar.showSuccess('Alteração realizada com sucesso.');
        }
    });

  }
  changeData(item) {
    return new Promise((resolve,reject)=>{
      this.spinner.show('main-card-view');
      
      let ob = {
        entityName:"Mktpcfg",
        IDCONF: item['IDCONF'],
        ACTIVE: item['ACTIVE']
      }
    
      this.sub2 = this.http.post(ob,'JsonBrokerServices/save',false,true,true).subscribe(async data=>{
        this.spinner.hide('main-card-view');
        resolve(true);
          
      },error=>{
          this.spinner.hide('main-card-view');
          if ( item['activeBOO']==true){
            item['ACTIVE']='N';
          }else{
            item['ACTIVE']='S';
          }
          item['activeBOO'] = false;
          throw error;
      });
    }); 
  }

  loadData(item) {
    return new Promise((resolve,reject)=>{
      this.spinner.show('main-card-view');
      let reload = false;
      if ( item != null){
          reload = true;  
      } 
      let ob = {
        entityName:"Mktpcfg",
        sql:`SELECT 
                    A.IDCONF,
                    A.NAME,
                    A.CODECOMPANY, 
                    B.NAME CODECOMPANY_NAME,
                    A.CODEMKTP,
                    C.NAME CODEMKTP_NAME,
                    A.IDTPI,
                    D.NAME IDTPI_NAME,
                    B.CODECONTRACT,
                    E.CONTRACTNAME,
                    A.ACTIVE,
                    A.SCHEDULE,
                    ISNULL(A.SERVERNAME,'Servidor Padrão') SERVERNAME,
                    'N' MULTI,
                    RETETIONDAYS,
                    A.CODECOMPANY AS CODECOMPANY_CAB, 
                    B.NAME CODECOMPANY_NAME_CAB,
                    ISNULL(A.ENVIRONMENT,1) AS ENVIRONMENT
              FROM MKTPCFG A (NOLOCK) INNER JOIN MKTPCOMPANIES B  (NOLOCK) ON A.CODECOMPANY=B.CODECOMPANY
                   INNER JOIN MKTPLACES C (NOLOCK) ON A.CODEMKTP=C.CODEMKTP
                   INNER JOIN MKTPTPI D (NOLOCK) ON  A.IDTPI = D.IDTPI
                   INNER JOIN MKTPCONTRACT E (NOLOCK) ON B.CODECONTRACT=E.CODECONTRACT
                   
              WHERE  ${this.uas.user.profile=='ADMIN' ? '0=0': "A.CODECOMPANY IN ("+this.uas.getCompanies()+")" } 
              AND ${reload? ' A.IDCONF = '+item["IDCONF"]: "0=0"} 
              AND NOT EXISTS ( SELECT 1 FROM MKTPCFGCOMPANY X (NOLOCK) WHERE A.IDCONF=X.IDCONF)
              UNION 
              SELECT  
                    A.IDCONF,
                    A.NAME, 
                    X.CODECOMPANY, 
                    B.NAME CODECOMPANY_NAME,
                    A.CODEMKTP,
                    C.NAME CODEMKTP_NAME,
                    A.IDTPI,
                    D.NAME IDTPI_NAME,
                    B.CODECONTRACT,
                    E.CONTRACTNAME,
                    A.ACTIVE,
                    X.SCHEDULE,
                    ISNULL(A.SERVERNAME,'Servidor Padrão') SERVERNAME,
                    'S' MULTI,
                    RETETIONDAYS,
                    A.CODECOMPANY AS CODECOMPANY_CAB, 
                    X1.NAME CODECOMPANY_NAME_CAB,
                    ISNULL(ISNULL(A.ENVIRONMENT,X.ENVIRONMENT),1) AS ENVIRONMENT
              FROM MKTPCFG A (NOLOCK)
                   INNER JOIN MKTPLACES C (NOLOCK) ON A.CODEMKTP=C.CODEMKTP
                   INNER JOIN MKTPTPI D (NOLOCK) ON A.IDTPI = D.IDTPI
                   LEFT OUTER JOIN MKTPCFGCOMPANY X (NOLOCK) ON A.IDCONF=X.IDCONF
                   LEFT JOIN MKTPCOMPANIES B (NOLOCK) ON X.CODECOMPANY=B.CODECOMPANY
                   LEFT JOIN MKTPCONTRACT E (NOLOCK) ON B.CODECONTRACT=E.CODECONTRACT
                   LEFT OUTER JOIN MKTPCOMPANIES X1 (NOLOCK) ON A.CODECOMPANY=X1.CODECOMPANY
              WHERE A.CODECOMPANY = 0 
              AND ${reload? ' A.IDCONF = '+item["IDCONF"]: "0=0"} 
              AND (
                 ${this.uas.user.profile=='ADMIN' ? '(0=0)': "(X.CODECOMPANY IN ("+this.uas.getCompanies()+"))" }  OR NOT EXISTS( SELECT 1 
                  FROM MKTPCFGCOMPANY X (NOLOCK) WHERE X.IDCONF=A.IDCONF) )`
      }
    
      this.sub2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(async data=>{
        this.spinner.hide('main-card-view');
        let confs:Object[] = data['SQL'];
        if ( reload ){
          if ( this.mktpcfg.length > 0 ){
            let index = this.mktpcfg.findIndex(idx=>idx['IDCONF'] == item['IDCONF']);
            if ( index > -1 ){
              this.mktpcfg[index] = this.transformLineData(confs)[0];
            }
          }  
        }else{
          this.mktpcfg = this.transformLineData(confs);
        }

        this.mktpcfg_temp = this.mktpcfg;
        this.loadLists();
        
        resolve(true);
          
      },error=>{
          this.spinner.hide('main-card-view');
          throw error;
      });
    }); 
  }
  
  
  transformLineData(confs: Object[]) {
    let lines:Object[] = [];
    
    for ( var line of confs){
        let index = lines.findIndex(d=>d['IDCONF']==line['IDCONF']);
        if ( index == -1 ){
            let ob = {
                IDCONF: line['IDCONF'],
                NAME: line['NAME'],
                CODEMKTP: line['CODEMKTP'],
                CODEMKTP_NAME: line['CODEMKTP_NAME'],
                IDTPI: line['IDTPI'],
                IDTPI_NAME: line['IDTPI_NAME'],
                ACTIVE: line['ACTIVE'],
                activeBOO: line['ACTIVE']=='S'? true: false,
                MULTI: line['MULTI'],
                RETETIONDAYS: line['RETETIONDAYS'],
                CODECOMPANY_CAB:line['CODECOMPANY_CAB'],
                CODECOMPANY_NAME_CAB: line['CODECOMPANY_NAME_CAB'],
                ENVIRONMENT:line['ENVIRONMENT'],
                DATA:[
                      {
                        CODECOMPANY:line['CODECOMPANY'],
                        CODECOMPANY_NAME: line['CODECOMPANY_NAME'],
                        SERVERNAME: line['SERVERNAME'],
                        SCHEDULE: line['SCHEDULE'],
                        CODECONTRACT: line['CODECONTRACT'],
                        CONTRACTNAME:line['CONTRACTNAME']
                      }
                ]
            }
            lines.push(ob);
        }else{
            (lines[index]['DATA'] as Object[]).push(
              {
                CODECOMPANY:line['CODECOMPANY'],
                CODECOMPANY_NAME: line['CODECOMPANY_NAME'],
                ACTIVE: line['ACTIVE'],
                activeBOO: line['ACTIVE']=='S'? true: false,
                SERVERNAME: line['SERVERNAME'],
                SCHEDULE: line['SCHEDULE'],
                CODECONTRACT: line['CODECONTRACT'],
                CONTRACTNAME:line['CONTRACTNAME']
              }
            );
        }
    }
    return lines;
  }
  
  

  loadCfgCompany() {
    
    return new Promise((resolve,reject)=>{
      this.spinner.show('main-card-view');
      let ob = {
        entityName:"Mktpcfgcompany",
        showImageData: false,
        showImageDataBase64: false,
        showPresentation: true,
    }
    
      this.sub2 = this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe(data=>{
          this.mktpcfgcompany = data['Mktpcfgcompany'];
          this.mktpcfgcompany = this.mktpcfg.map(d=>({ ...d}));
          this.mktpcfgcompany_temp = this.mktpcfgcompany;
          this.spinner.hide('main-card-view');
          resolve(true);
      },error=>{
          this.spinner.hide('main-card-view');
      });
    }); 
  }

  filterOptions(evento,clearAll:boolean,listName){
    
    if ( clearAll){
        this[listName+'Filtered'].push(...this[listName]);
    }

    if (evento){
      this[listName+'Filtered']= this[listName].filter((value)=>{
        if (evento == null || value['name']==null){
          return false;
        }
        if ( value['name'].toLowerCase().indexOf( evento.toLowerCase())>-1) {
          return true;
        }else{
          return false;
        }
      });
    }else{
      this[listName+'Filtered']= this[listName];
    }

  }

  loadLists(){
      
      this.marketPlaceList = Array.from(new Set(this.mktpcfg_temp.map(item=>item['CODEMKTP']))).map(d=>({key:d,name:this.mktpcfg_temp.find(x=>x['CODEMKTP']==d)['CODEMKTP_NAME']})).sort((data,data2)=>{
          if ( data.name > data2.name  ) return 1;
          if ( data.name < data2.name  ) return -1;
          return 0;
      });

      this.marketPlaceListFiltered = Array.from(new Set(this.mktpcfg_temp.map(item=>item['CODEMKTP']))).map(d=>({key:d,name:this.mktpcfg_temp.find(x=>x['CODEMKTP']==d)['CODEMKTP_NAME']})).sort((data,data2)=>{
        if ( data.name > data2.name  ) return 1;
        if ( data.name < data2.name  ) return -1;
        return 0;
    });

      this.typeList = Array.from(new Set(this.mktpcfg_temp.map(item=>item['IDTPI']))).map(d=>({key:d,name:this.mktpcfg_temp.find(x=>x['IDTPI']==d)['IDTPI_NAME']})).sort((data,data2)=>{
        if ( data.name > data2.name  ) return 1;
        if ( data.name < data2.name  ) return -1;
        return 0;
      });

      this.typeListFiltered = Array.from(new Set(this.mktpcfg_temp.map(item=>item['IDTPI']))).map(d=>({key:d,name:this.mktpcfg_temp.find(x=>x['IDTPI']==d)['IDTPI_NAME']})).sort((data,data2)=>{
        if ( data.name > data2.name  ) return 1;
        if ( data.name < data2.name  ) return -1;
        return 0;
      });


      let setCompanySet = new Set();
      this.mktpcfg_temp.forEach(item=>{
          let data = item['DATA'] as Object[];
          new Set(data.map(v=>(JSON.stringify({codecompany:v['CODECOMPANY'], name:v['CODECOMPANY_NAME']})))).forEach(d=>{
            setCompanySet.add(d);
          });
      });
      
    
      this.companyList = Array.from(setCompanySet).map((d:string)=>({key:JSON.parse(d).codecompany,name:JSON.parse(d).name})).sort((data,data2)=>{
        if ( data.name > data2.name  ) return 1;
        if ( data.name < data2.name  ) return -1;
        return 0;
      });

      this.companyListFiltered  = Array.from(setCompanySet).map((d:string)=>({key:JSON.parse(d).codecompany,name:JSON.parse(d).name})).sort((data,data2)=>{
        if ( data.name > data2.name  ) return 1;
        if ( data.name < data2.name  ) return -1;
        return 0;
      });

      let serverListSet = new Set();
      this.mktpcfg_temp.forEach(item=>{
          let data = item['DATA'] as Object[];
          new Set(data.map(v=>v['SERVERNAME'])).forEach(d=>{
            serverListSet.add(d);
          });
      });

      this.serverList =  Array.from(serverListSet).map((d:string)=>({key:d,name:d})).sort((data,data2)=>{
        if ( data.name > data2.name  ) return 1;
        if ( data.name < data2.name  ) return -1;
        return 0;
      });

  }


  doFilter(filterValue:string){

    if ( filterValue != null && filterValue!=''){
      this.filterColor = 'warn';
    }else{
      this.filterColor='primary';
    }

    if ( this.controle.length == 0 ){
      this.mktpcfg= this.mktpcfg_temp.filter((data) => {
        return data.NAME.toUpperCase().indexOf(filterValue.toUpperCase()) > -1 ? true : false||
              String(data.IDCONF).toUpperCase().indexOf(filterValue.toUpperCase()) > -1 ? true : false
      });
    }else{
      this.mktpcfg= this.mktpcfg.filter((data) => {
        return data.NAME.toUpperCase().indexOf(filterValue.toUpperCase()) > -1 ? true : false
      });
    }
    this.recalculateView(this.widthScrollContainer);
  }

  updateFilter(event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.doFilter(filterValue)
    
  }

  recalculateView(value:number){
    let innerWidth = value;
    let inteiro = Math.trunc(innerWidth / this.minWidth);
    let descontos = ((inteiro*2) * 5) + 24;
    
    this.width = Math.trunc(((innerWidth - descontos) / inteiro) );
    
    this.cd.markForCheck();
  }

  // recalculateView(tipo){
  //   setTimeout(()=>{
  //     let size:number = this.cdkVirtualScrollViewport.getViewportSize();
  //     if ( tipo =='E'){
  //         size = size - 240;
  //     } 
  //     //this.cdkVirtualScrollViewport.setTotalContentSize(size);
  //   },100);
  // }

  editarDados(item, insert){
    this.gridMode = false;
    this.insert = insert;
    this.mountEdition(item,insert);
  }
  
  mountEdition(item: any, insert: boolean) {
    this.data = {
      evento: insert ? 'inserindo':'editando',
      row: item,
      formGroup: null
    }
  }

  getCompanyName(d: any): any {
    let findCfg = this.mktpcfg_temp.find(x=>x['DATA']['CODECOMPANY']==d);
    return findCfg['DATA']['CODECOMPANY_NAME'];
  }


  openContext(evento,item){
    
    this.dialogServices.openGenericDialog(MultipleContextComponent,item,(popUpData)=>{
        this.loadData(item);
    },
    ()=>{
    },'100%');
  }

  executeEvent(evento,item){
    let action:action ={
        IDCONF:item['IDCONF'],
        CODECOMPANY: null,
        EXPRESSION:  JSON.stringify({idConf:item['IDCONF']}),
        ICON: null,
        IDACTION: null,
        IDINSTANCE: null,
        NAME: item['NAME'],
        SELECTED:item,
        PARAMETERS: null,
        TYPE:"C"
    }
    let flowData: flowData = {
      selected: item,
      action: action,
      function: null,
      parameters: null
    };
    this.dialogServices.openGenericDialog(FlowModalComponent,flowData,(popUpData)=>{},
    ()=>{
    },'90vh','90vw',true,null,'S','20px');
  }

  openLog(evento,item){
    this.dialogServices.openGenericDialog(ConfigLogComponent,item,(popUpData)=>{},
    ()=>{
    },'90vh','90vw',false,null,'S','20px');
  }

  addNewItem(){
    this.openMenu =!this.openMenu;
    this.gridMode = false;
    this.insert = true;
    this.mountEdition({},this.insert);    
  }

  wizardChange(event){
      if ( event ){
        this.loadData(null);
      }
  }

  kill(event, item){
      
      let ob:OptionDialogItens[] = [];
      let idconf = item['IDCONF'];
      
      if ( this.threads == null ){
          this.snackbar.showInformation('Informações de Execução não carregadas. Ativar atualização de informações no menu.');
          return;          
      }

      Object.keys(this.threads).forEach(serverName=>{
          (this.threads[serverName] as Object[]).forEach( (threads:string) =>{
              let threadName:string = threads['name'];
              let threadIdconf:string = threadName.split('_')[1];
              //let codemktp:string = threadName.split('_')[2];
              //let idtpi:string = threadName.split('_')[3];
              let codecompany:string = threadName.split('_')[4];

              if ( threadIdconf == idconf  ){
                let thread:OptionDialogItens = {
                  key:serverName+"-"+threads['name'],
                  value: threads['name']
                }
                ob.push(thread);
              }
          });
      });
      
      
          
      this.dialogServices.openOptionDialog('Seleção de Thread',ob,
        (value)=>{
            let valueStr = (value as String);
            let threadToKill = valueStr.substring(valueStr.indexOf('IntegracaoMarketPlaceJobThread'));
            let serverName = valueStr.substring(0,valueStr.indexOf('IntegracaoMarketPlaceJobThread') - 1);
            let ob = {
                serverName: serverName,
                threadName: threadToKill
            }

            this.threadKill = this.http.post(ob,'SystemServices/kill',false,true,true).subscribe({
                next:(value)=>{
                    let morto = value['resultado'];
                    if ( morto == 'Morto'){
                      this.snackbar.showSuccess('workflow.success.kill.thread');
                    }else{
                      this.snackbar.showError(morto);
                    }
                }
            })

        },
        ()=>{},'400px','120px')
    
  }
}


